import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]

  connect() {
    // Ensure menu is closed on connect (fresh page load or Turbo navigation)
    this.ensureClosed()

    // Close menu before Turbo caches the page to prevent stale state
    document.addEventListener("turbo:before-cache", this.handleBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache)
  }

  handleBeforeCache = () => {
    this.ensureClosed()
  }

  ensureClosed() {
    if (this.hasMenuTarget && this.hasOverlayTarget) {
      this.menuTarget.classList.add("-translate-x-full")
      this.overlayTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      this.menuTarget.setAttribute("aria-hidden", "true")
      // inert removes the off-screen drawer's links from the tab order too,
      // not just the a11y tree (aria-hidden alone leaves them keyboard-focusable).
      this.menuTarget.inert = true
    }
  }

  toggle() {
    if (this.menuTarget.classList.contains("-translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("-translate-x-full")
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.menuTarget.setAttribute("aria-hidden", "false")
    this.menuTarget.inert = false
    this.menuTarget.querySelector("a, button")?.focus()
  }

  close() {
    this.menuTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.menuTarget.setAttribute("aria-hidden", "true")
    this.menuTarget.inert = true
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
